/**
 * Prevent focus on Skip To Main CTA if the last thing that get the focus is the Cookie Consent
 */
import { focusableChildren } from '../../utils/functions';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  return async () => {
    let lastFocusElement = null;

    document.addEventListener('focusin', (ev) => {
      const elConsent = document.getElementById('onetrust-consent-sdk');
      if (elConsent && (lastFocusElement && (lastFocusElement === elConsent || elConsent.contains(lastFocusElement)))) {
        if (ev.target.nodeName === 'A' && ev.target.classList.contains('skip-main')) {
          const focusables = focusableChildren(document.body);
          const focusable = focusables.find(f => {
            if (f.classList.contains('skip-main') || f.id == 'main') {
              return false;
            }
  
            return true;
          });
  
          if (focusable) {
            focusable.focus();
          }
        }
      }

      lastFocusElement = ev.target;
    });
  };
})(jQuery, window);